<template>
    <!-- NAVBAR SEARCH TRIGGER -->
    <div class="h-full" id="nav_searchbar">
        <div 
            class="h-full block flex items-center justify-center px-6 cursor-pointer">
            <div class="flex items-center pr-2 border border-gray-300 rounded-full max-w-[400px] justify-between" @click.self="openLocationSearch">
                <div class="flex justify-center items-center group max-w-[90%]" @click.self="openLocationSearch">
                    <span id="nav_searchbar_location" @click.self="openLocationSearch" class="truncate inline-block grow-0 shrink py-4 px-5 rounded-full md:hover:scale-95 md:hover:bg-gray-100 md:dark:hover:bg-gray-100 md:dark:hover:bg-opacity-30 transition duration-300 capitalize">
                        {{ locationName ?? listingType }}
                    </span>
                    <div
                        class="hidden md:block h-full min-h-[1.5em] w-[2px] bg-gray-300 my-2 group-hover:bg-white dark:group-hover:bg-transparent transition duration-300 rounded-full">
                    </div>
                    <span id="calendarbutton" @click.self="openCalendarSearch" class="pl-4 py-4 pr-4 inline-block grow rounded-full shrink-0 hover:scale-95 md:hover:bg-gray-100 md:dark:hover:bg-gray-100 md:dark:hover:bg-opacity-30 transition duration-300">{{checkin ?? 'Checkin'}} - {{checkout ?? 'Checkout'}}</span>
                </div>
                <button aria-label="Search" class="bg-primary rounded-full text-white h-10 w-10 shrink-0 flex justify-center items-center md:hover:scale-95 transition duration-300  active:bg-primary-dark active:!scale-75" @click.self="performSearch" >
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 pointer-events-none" fill="currentColor"
                        viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
                        <path
                            d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>
  
<script>
import VueCookies from 'vue-cookies'
import moment from "moment";

export default {
    data() {
        return {
            location: null,
            locationName: null,
            checkin: null,
            checkout: null,
            listingType: null,
        };
    },
    methods: {
        openLocationSearch(e) {
            if (e.target.id != "calendarbutton") {
                this.$root.$emit("showLocationSearch", true);
            }
        },
        openCalendarSearch() {
            this.$root.$emit("showCalendarSearch", true);
        },
        performSearch() {
            var url = this.$homeUrl + '/accomodations/?numAdult=' + parseInt(VueCookies.get('numAdult')) + '&numChildren=' + parseInt(VueCookies.get('numChildren'));

            if (VueCookies.get('checkin')) {
                url = url + '&checkin=' + moment(VueCookies.get('checkin')).format('YYYYMMDD')
            }
            if (VueCookies.get('checkout')) {
                url = url + '&checkout=' + moment(VueCookies.get('checkout')).format('YYYYMMDD')
            }
            if (VueCookies.get('searchlocation')) {
                var location = VueCookies.get('searchlocation');
                if (location.hasOwnProperty('nonHome')) {
                    url = url + '&' + encodeURIComponent(location.nonHome) + '=' + encodeURIComponent(location.name);
                } else {
                    url = url + '&name=' + encodeURIComponent(location.name);
                }
            }

            window.location.href = url;
        }
    },

    mounted() {
        const clientVars = this.$attrs.clientvariables ? JSON.parse(this.$attrs.clientvariables) : {};
        this.listingType = clientVars['listing_type'].split(',')[0];

        this.$root.$on("locationChange", (msg) => {
            this.location = VueCookies.get('searchlocation');
            this.locationName = VueCookies.get('searchlocation').name;
        });
        this.$root.$on("checkinSelect", (msg) => {
            this.checkin = moment(VueCookies.get('checkin')).format('Do MMM');
        });
        this.$root.$on("checkoutSelect", (msg) => {
            this.checkout = moment(VueCookies.get('checkout')).format('Do MMM');
        });
    },

    filters: {
        smallDate: function (date) {
            return moment(date).format('Do MMM');
        }
    },

    created() {
        moment.locale(document.documentElement.lang);
        this.currentUrl = this.$attrs.base_url;

        if (VueCookies.get('searchlocation')) {
            this.location = VueCookies.get('searchlocation')
            this.locationName = VueCookies.get('searchlocation').name;
        }

        if (VueCookies.get('checkin')) {
            this.checkin = moment(VueCookies.get('checkin')).format('Do MMM');
        }

        if (VueCookies.get('checkout')) {
            this.checkout = moment(VueCookies.get('checkout')).format('Do MMM');
        }
    },
};
</script>
  